import { format, parseISO, isValid } from "date-fns";
import { fr } from "date-fns/locale";

export const CLIENT_TYPES = { particulier: "Particulier", professionnel: "Professionnel" };

export const INTERVENTION_TYPES = {
  maintenance_preventive: "Maintenance préventive",
  depannage: "Dépannage",
  installation: "Installation",
  configuration: "Configuration",
  wifi_reseau: "Wi-Fi & réseau",
  assistance_distance: "Assistance à distance",
};

export const INTERVENTION_STATUS = {
  a_planifier: "À planifier", planifiee: "Planifiée", en_cours: "En cours", a_finaliser: "À finaliser", termine: "Terminée", annulee: "Annulée",
};
export const CATEGORY_LABELS = {
  today: "Aujourd'hui", upcoming: "À venir", upcoming_7: "7 prochains jours", to_plan: "À planifier", in_progress: "En cours", late: "En retard",
  to_finalize: "À finaliser", done: "Terminées", reports_to_send: "Bons à envoyer", to_bill: "À facturer", to_bill_out: "Hors contrat à facturer", drafts: "Brouillons",
  workshop: "En atelier", workshop_diag: "Atelier : à diagnostiquer", workshop_wait: "Atelier : attente pièce/accord", workshop_repair: "Atelier : en réparation",
  workshop_ready: "Atelier : prêts à récupérer", workshop_returned: "Atelier : restitués",
};
export const FILE_CATEGORIES = {
  avant: "Avant intervention", diagnostic: "Panne ou diagnostic", pendant: "Pendant l'intervention", apres: "Après intervention", document: "Document",
};
export const plural = (n, one, many = `${one}s`) => `${n} ${n > 1 ? many : one}`;
export const MODES = { site: "Chez le client", atelier: "En atelier", distance: "À distance" };
export const WORKSHOP_STAGES = {
  attente_diagnostic: "En attente de diagnostic", diagnostic_en_cours: "Diagnostic en cours", attente_piece: "En attente de pièce ou d'accord",
  reparation: "Réparation en cours", pret: "Prêt à récupérer", restitue: "Restitué au client",
};
export const STAGE_TONE = { attente_diagnostic: "orange", diagnostic_en_cours: "cyan", attente_piece: "orange", reparation: "cyan", pret: "green", restitue: "grey" };
export const ACCESSORIES = ["Chargeur", "Câble", "Sacoche", "Souris", "Clavier", "Disque externe", "Boîte"];
export const EQUIPMENT_TYPES = {
  pc_fixe: "PC fixe", portable: "Ordinateur portable", imprimante: "Imprimante", serveur: "Serveur", nas: "NAS", routeur: "Routeur / box",
  switch: "Switch", wifi: "Équipement Wi-Fi", onduleur: "Onduleur", ecran: "Écran", telephone: "Téléphone", tablette: "Tablette", autre: "Autre",
};
export const SPEC_FIELDS = { cpu: "Processeur", ram: "Mémoire RAM", storage: "Stockage", os: "Système", ip: "Adresse IP", other: "Autres infos" };
export const CONTRACT_TYPES = { forfait: "Forfaitaire", credit_heures: "Crédit d'heures", preventive: "Maintenance préventive", mixte: "Mixte" };
export const CONTRACT_STATUS = { brouillon: "Brouillon", actif: "Actif", a_renouveler: "À renouveler", expire: "Expiré", suspendu: "Suspendu", resilie: "Résilié" };
export const PERIODS = { mensuel: "Mensuel", trimestriel: "Trimestriel", semestriel: "Semestriel", annuel: "Annuel" };
export const PAYMENT_STATUS = { a_completer: "Règlement à compléter", en_attente: "En attente de règlement", partielle: "Partiellement payée", en_retard: "En retard de paiement", payee: "Payée" };
export const BILLING_STATUS = { non_facturee: "Non facturée", facturee: "Facturée", offerte: "Offerte", non_facturable: "Non facturable" };
export const LINE_KINDS = {
  materiel: "Matériel", logiciel: "Logiciel / licence", prestation: "Prestation", deplacement: "Déplacement", autre: "Autre frais", remise: "Remise",
};
export const LINE_BILLING = { facturable: "Facturable", offert: "Offert", non_facturable: "Non facturable" };
export const ROUNDING = { none: "Sans arrondi", quarter: "Quart d'heure supérieur", half: "Demi-heure supérieure", min_hour: "Minimum 1 h puis quart d'heure" };
export const BACKUP_STATE = {
  success: "Réussie", partial: "Échec partiel", failed: "Échec", running: "En cours", missing: "Non exécutée", stuck: "Bloquée", unknown: "Aucune donnée", test_only: "Tests uniquement",
};
export const fmtMin = (m) => `${Math.floor((m || 0) / 60)} h ${String((m || 0) % 60).padStart(2, "0")}`;
export const fmtBytes = (b) => {
  if (b == null) return "—";
  const u = ["o", "Ko", "Mo", "Go", "To"];
  let i = 0;
  let n = b;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i += 1; }
  return `${n.toLocaleString("fr-FR", { maximumFractionDigits: 1 })} ${u[i]}`;
};
export const PRIORITIES = { basse: "Basse", normale: "Normale", haute: "Haute", urgente: "Urgente" };
export const fmtDuration = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  const p = (n) => String(n).padStart(2, "0");
  return `${p(Math.floor(s / 3600))} h ${p(Math.floor((s % 3600) / 60))} min ${p(s % 60)} s`;
};

export const ORDER_CATEGORIES = {
  pc: "PC",
  ecran: "Écran",
  imprimante: "Imprimante",
  affichage_dynamique: "Affichage dynamique",
  reseau: "Réseau",
  autre: "Autre",
};

export const ORDER_STATUS = {
  a_commander: "À commander",
  commande: "Commandé",
  recu: "Reçu",
  livre: "Livré / installé",
  annule: "Annulé",
};

export const REMINDER_KINDS = { suivi: "Suivi client", maintenance: "Maintenance" };

export const NOTIF_KINDS = { confirmation: "Confirmation", modification: "Modification", cancellation: "Annulation" };
export const NOTIF_STATUS = {
  pending: "En attente",
  sending: "En cours d'envoi",
  sent: "Transmis au serveur d'envoi",
  error: "Erreur d'envoi",
  no_email: "Non envoyé : pas d'e-mail",
  disabled: "Notification désactivée",
};
export const NOTIF_STYLE = {
  pending: "text-amber-300", sending: "text-amber-300", sent: "text-emerald-300", error: "text-red-300", no_email: "text-slate-400",
};
export const OUTLOOK_STATUS = {
  pending: "Outlook : en attente", synced: "Outlook : synchronisé", conflict: "Outlook : conflit", error: "Outlook : erreur",
  unscheduled_by_outlook: "Déplanifiée depuis Outlook",
};

export const ROLES = { admin: "Administrateur", technicien: "Technicien" };

const AMBER = "bg-amber-500/15 text-amber-300 border-amber-500/30";
const CYAN = "bg-cyan-400/15 text-cyan-300 border-cyan-400/30";
const GREEN = "bg-emerald-500/15 text-emerald-300 border-emerald-500/30";
const BLUE = "bg-blue-500/15 text-blue-300 border-blue-500/30";
const SLATE = "bg-slate-500/15 text-slate-300 border-slate-500/30";
const RED = "bg-red-500/15 text-red-300 border-red-500/40";
const VIOLET = "bg-indigo-400/15 text-indigo-200 border-indigo-400/30";

export const STATUS_STYLES = {
  a_planifier: AMBER,
  planifiee: BLUE,
  en_cours: CYAN,
  a_finaliser: VIOLET,
  termine: GREEN,
  annulee: SLATE,
  a_commander: AMBER,
  commande: CYAN,
  recu: BLUE,
  livre: GREEN,
  annule: SLATE,
  suivi: VIOLET,
  maintenance: AMBER,
  particulier: BLUE,
  professionnel: CYAN,
  overdue: RED,
  admin: CYAN,
  technicien: SLATE,
  non_facturee: AMBER,
  facturee: GREEN,
  offerte: CYAN,
  non_facturable: SLATE,
  facturable: GREEN,
  offert: CYAN,
  success: GREEN,
  partial: AMBER,
  failed: RED,
  missing: RED,
  stuck: RED,
  running: CYAN,
  unknown: SLATE,
  brouillon: SLATE,
  actif: GREEN,
  a_renouveler: AMBER,
  expire: RED,
  suspendu: AMBER,
  resilie: SLATE,
  en_attente: AMBER,
  a_completer: SLATE,
  partielle: CYAN,
  en_retard: RED,
  payee: GREEN,
};

const safeFormat = (s, pattern, fallback) => {
  if (!s) return fallback;
  const d = parseISO(s);
  return isValid(d) ? format(d, pattern, { locale: fr }) : s;
};
export const fmtDate = (s) => safeFormat(s, "d MMM yyyy", "—");
export const fmtDateTime = (s) => safeFormat(s, "EEE d MMM yyyy · HH:mm", "Non planifiée");
export const fmtTime = (s) => safeFormat(s, "HH:mm", "—");
export const todayStr = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris" }).format(new Date());
export const fmtParis = (s) => (s ? new Date(s).toLocaleString("fr-FR", { timeZone: "Europe/Paris", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const canTime = (i) => !i.draft && !["annulee", "termine"].includes(i.status);
export const fmtPrice = (n) =>
  n == null ? "—" : new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
